<template>
  <div>
    <div v-if="!unlocked" class="preview-lock">
      <form class="preview-lock-box" @submit.prevent="checkPassword">
        <h2 class="preview-lock-title">Protected Preview</h2>
        <p class="preview-lock-sub">
          Please enter the password to view this page.
        </p>
        <input
          v-model="passwordInput"
          type="password"
          class="preview-lock-input"
          placeholder="Password"
          autofocus
        />
        <button type="submit" class="btn preview-lock-btn">Enter</button>
        <p v-if="error" class="preview-lock-error">
          Incorrect password. Please try again.
        </p>
      </form>
    </div>
    <Home v-else class="home-flat" />
  </div>
</template>

<script>
import Home from "./Home.vue";

export default {
  name: "HomePreview",
  components: { Home },
  data: () => ({
    unlocked: false,
    passwordInput: "",
    error: false,
    previewPassword: "playworks2026",
  }),
  methods: {
    checkPassword() {
      if (this.passwordInput === this.previewPassword) {
        this.unlocked = true;
        this.error = false;
        try {
          localStorage.setItem("homePreviewUnlocked", "true");
        } catch (e) {
          // ignore storage errors
        }
      } else {
        this.error = true;
      }
    },
  },
  created() {
    try {
      if (localStorage.getItem("homePreviewUnlocked") === "true") {
        this.unlocked = true;
      }
    } catch (e) {
      // ignore storage errors
    }
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    meta.setAttribute("data-home-preview-noindex", "true");
    document.head.appendChild(meta);
  },
  beforeDestroy() {
    const meta = document.head.querySelector(
      'meta[data-home-preview-noindex="true"]',
    );
    if (meta) document.head.removeChild(meta);
  },
};
</script>
